window.jobComponent = function (items, itemsPerPage, locations, types, groups) {
    return {
        items,
        page: 1,
        perPage: itemsPerPage,

        locationFilterOpen: false,
        typeFilterOpen: false,
        jobsiteFilterOpen: {},

        locations,
        types,
        groups,

        locationFilter: [],
        typeFilter: [],
        jobsiteFilter: {},

        init() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            let locationParams = urlParams.get('location');
            let typeParams = urlParams.get('type');
            this.locationFilter = locationParams ? locationParams.split(',').map(item => item.trim()) : [];
            this.typeFilter = typeParams ? typeParams.split(',').map(item => item.trim()) : [];
            this.groups.forEach(group => {
                let filterName = this.parseFilterNameFromGroup(group);
                let groupParams = urlParams.get(filterName);
                this.jobsiteFilter[filterName] = groupParams ? groupParams.split(',').map(item => item.trim()) : [];
            });
        },
        openJobsiteFilter(groupId) {
            this.jobsiteFilterOpen[groupId] = !this.jobsiteFilterOpen[groupId];
        },
        jobsiteFilterTemplate(groupId) {
            return `
                <template x-for="filter in jobsiteFilters(${groupId})">
                    <li class="mb-8 -mt-8 flex items-center pl-12 pr-16 py-4 hover:bg-primary-5" x-on:click="jobsiteFilterSelected(${groupId}, filter)">
                        <input type="checkbox" class="mr-10" :checked="jobsiteFilterContains(${groupId}, filter)">
                        <span class="block cursor-pointer whitespace-nowrap" x-text="filter.alias"></span>
                    </li>
                </template>
            `;
        },
        jobsiteFilterContains(groupId, filter) {
            if (!filter.id) {
                // Default filter
                return this.jobsiteFilterLength(groupId);
            }
            let groupName = this.parseFilterNameFromGroup(this.groups.find(group => group.id === groupId));
            return this.jobsiteFilter[groupName] && this.jobsiteFilter[groupName].includes(filter.alias);
        },
        jobsiteFilterLength(groupId) {
            let group = this.groups.find(group => group.id === groupId);
            let groupName = this.parseFilterNameFromGroup(group);
            return !(this.jobsiteFilter[groupName] && this.jobsiteFilter[groupName].length);
        },
        jobsiteFilters(groupId = null) {
            let allGroups = JSON.parse(JSON.stringify(this.groups))
            return allGroups.find(group => group.id === groupId).filters;
        },
        allGroups() {
            return this.groups;
        },
        filteredItems() {
            return this.items.filter((job) =>
                this.locationFilterCorrect(job) &&
                this.typeFilterCorrect(job) &&
                this.jobsiteFilterCorrect(job)
            )
        },
        filteredItemsOnThisPage() {
            return this.filteredItems().filter((job, i) => this.isOnCurrentPage(i));
        },
        totalPages() {
            return Math.ceil(this.filteredItems().length / this.perPage);
        },
        loopPages() {
            let loop = [];
            for (let i = 0; i < this.totalPages(); i++) {
                loop.push(i + 1);
            }
            return loop;
        },
        locationFilterCorrect(job) {
            if (!this.locationFilter.length) {
                // No location filters selected, show all items
                return true;
            }
            return this.locationFilter.length > 0 && this.locationFilter.some(filterAlias => {
                const filter = this.locations.find(filter => filter.alias === filterAlias);
                return filter ? job.filters.locationId === filter.id : false;
            })
        },
        typeFilterCorrect(job) {
            if (!this.typeFilter.length) {
                // No type filters selected, show all items
                return true;
            }
            return this.typeFilter.length > 0 && this.typeFilter.some(filterAlias => {
                const filter = this.types.find(filter => filter.alias === filterAlias);
                return filter ? job.filters.types.includes(filter.id) : false;
            });
        },
        jobsiteFilterCorrect(job) {
            if (!Object.values(this.jobsiteFilter).flatMap(item => item).length) {
                // No group filters selected, show all items
                return true;
            }

            return Object.keys(this.jobsiteFilter).every(groupName => {
                const jobsiteFilters = this.jobsiteFilter[groupName];
                return jobsiteFilters.length === 0 || jobsiteFilters.some(filterAlias => {
                    const group = this.groups.find(group => this.parseFilterNameFromGroup(group) === groupName);
                    if (group) {
                        const filter = group.filters.find(filter => filter.alias === filterAlias);
                        return filter && job.filters.filterIds.includes(filter.id);
                    }
                    return false;
                });
            });
        },
        isOnCurrentPage(index) {
            return index >= this.perPage * (this.page - 1) && index < this.perPage * this.page;
        },
        containsLocation(filter) {
            return this.locationFilter.includes(!isNaN(filter) ? filter : filter.alias);
        },
        containsType(filter) {
            return this.typeFilter.includes(filter !== '' && !filter.id ? filter : filter.alias);
        },
        containsGroup(groupId, filter) {
            let groupName = this.parseFilterNameFromGroup(this.groups.find(group => group.id === groupId));
            if (groupName in this.jobsiteFilter) {
                return this.jobsiteFilter[groupName].includes(filter.alias);
            }
            return false;
        },
        locationFilterSelected(filter) {
            if (!!filter.id) {
                if (this.containsLocation(filter)) {
                    this.locationFilter = this.locationFilter.filter(item => item !== filter.alias);
                } else {
                    this.locationFilter.push(filter.alias);
                }
            } else {
                // Empty the array when the default filter is selected
                this.locationFilter = [];
            }
            this.page = 1;
            this.updateUrl();
        },
        typeFilterSelected(filter) {
            if (!!filter.id) {
                if(this.containsType(filter)){
                    this.typeFilter = this.typeFilter.filter(item => item !== filter.alias);
                }else{
                    this.typeFilter.push(filter.alias);
                }
            }else{
                this.typeFilter = [];
            }
            this.page = 1;
            this.updateUrl();
        },
        jobsiteFilterSelected(groupId, filter) {
            let group = this.groups.find(group => group.id === groupId);
            let groupName = this.parseFilterNameFromGroup(group);

            if (!!filter.id) {
                if (!this.jobsiteFilter[groupName]) this.jobsiteFilter[groupName] = [];

                if (this.containsGroup(groupId, filter)) {
                    this.jobsiteFilter[groupName] = this.jobsiteFilter[groupName].filter(item => item !== filter.alias);
                } else {
                    this.jobsiteFilter[groupName].push(filter.alias);
                }
            } else {
                // Empty the array when the default filter is selected
                this.jobsiteFilter[groupName] = [];
            }

            this.page = 1;
            this.updateUrl();
        },
        updateUrl() {
            let baseUrl = `${window.location.origin}${window.location.pathname}?`;
            let params = new URLSearchParams();

            // Handle location filter
            if (this.locationFilter.length > 0) {
                params.append('location', this.locationFilter.join(','));
            }

            // Handle type filter
            if (this.typeFilter.length > 0) {
                params.append('type', this.typeFilter.join(','));
            }

            // Handle group filters
            for (const groupName in this.jobsiteFilter) {
                if (this.jobsiteFilter[groupName].length > 0) {
                    params.append(groupName, this.jobsiteFilter[groupName].join(','));
                }
            }
            baseUrl += params.toString();
            window.history.replaceState({
                id: 'homepage'
            }, document.title, baseUrl);
        },
        parseFilterNameFromGroup(group) {
            return group.alias.split(" ").join("_").toLowerCase();
        },
        paginate(page) {
            this.page = page;

            //When there are less vacancies on an other page,
            //and the content height is there for smaller
            //you can't immediately scrollTo that element.
            //That is why we have a setTimeout
            setTimeout(function () {
                //Scroll to the element
                window.scrollTo({top: document.getElementById("vacatures").offsetTop - 150});
                // document.getElementById("vacatures").scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
            }, 50);
        }
    }
}
